module.exports = __webpack_public_path__ + "static/media/publishWitnessLogo.4d953fd8.webp";